import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SkipLoading } from '../interceptors/app_interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  Vision_Warehouse: string = '';
  DB_Service: string = '';
  File_Service: string = '';
  Celery: string = '';
  Storage_CDN: string = '';

  constructor(public http: HttpClient, private _sanitizer: DomSanitizer) { }

  getProfile() {
    return this.http.get(environment.apiConfig.uri);
  }

  get_user_image(): Observable<Blob> {
    return this.http
      .get(environment.apiConfig.uri + '/photo/$value', {
        responseType: 'blob',
        headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
      }).pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  search_moments(body: any) {
    // return this.http.get('assets/mock_data/search_result.json');
    return this.http.post(this.Vision_Warehouse + '/search-moments', body);
  }

  list_all_corpora() {
    return this.http.get(this.Vision_Warehouse + '/corpus');
  }

  get_transcript_and_diarization(video_data: any) {
    return this.http.get('assets/mock_data/transcript_and_diarization.json');
    // return this.http.get(this.Vision_Warehouse + '/corpus');
  }

  get_all_videos(corpus_name: string) {
    return this.http.get(this.Vision_Warehouse + `/asset?corpus=${corpus_name}`);
  }

  async get_trimmed_video(body: any) {
    // return this.http.get('assets/mock_data/thumbnails.png', { responseType: 'blob' });
    return this.http.post(this.Vision_Warehouse + '/asset/trim', body, {
      responseType: 'blob',
      context: new HttpContext().set(SkipLoading, true)
    });
  }

  get_merged_video(body: any): Observable<Blob> {
    return this.http.post(this.Vision_Warehouse + '/asset/merge',  Array.from(new Set(body)), { responseType: 'blob' });
  }

}
